import { ACCESS_TOKEN } from 'app/constants/LOCALKEYS'
import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../persist'

const KEY = '@LOCAL:DEVKEY'

let swrData: string | null = getPersistData(KEY)

export function useDevKey() {
	const { data, mutate } = useSWR<string | null>(KEY, async () => {
		return swrData
	})

	return {
		data,
		mutate: (value: string | null) => {
			swrData = value
			return mutate()
		},
	}
}
